"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.toExecuteInfo = void 0;
const FlowConfig_1 = __importDefault(require("@/class/FlowConfig"));
const utils_1 = require("@/config/utils");
const router_1 = __importDefault(require("@/pages/index/router"));
const executeFlowConfig = new FlowConfig_1.default({
    list: [
        'ufo_cs_zx_10',
        'ufo_cs_zx_20',
        'ufo_cs_zx_30',
        'ufo_cs_zx_40',
        'ufo_cs_zx_50',
        'ufo_cs_zx_60',
        'ufo_cs_zx_70',
        'ufo_cs_zx_80', // 结束
    ]
});
const toExecuteInfo = function (executeId, flowId, flowKey) {
    if (flowKey === 'start') {
        flowKey = executeFlowConfig.getBuild();
    }
    else if (flowKey === 'end') {
        flowKey = executeFlowConfig.getEnd();
    }
    router_1.default.push(`/litigation/execute/info/${executeId}/${(0, utils_1.simpleEncrypt)(flowId)}/${(0, utils_1.simpleEncrypt)(flowKey)}`);
};
exports.toExecuteInfo = toExecuteInfo;
exports.default = executeFlowConfig;
